import config from "./Api-config";
import storage from "@/storage/storage";
import PermissionHelper from "@/permissions/PermissionHelper";
import {IAuthToken} from "@/interface/IAuthToken";

const Auth = {
  async IsLogin() {
    const url = window.location;
    const params = new URLSearchParams(url.search);
    const tokenParam = params.get("token");
    let token:string|null = null;
    let valid = false;

    if(tokenParam && tokenParam.length>5){
      token = tokenParam;
      await this.SetToken(tokenParam);
      params.delete("token");
      window.location.href = url.origin+url.pathname+"?"+params.toString();
    }else{
      token = await storage.getItem(config.STORAGE_KEYS.TOKEN);
    }
    valid = token !== null;
    if (valid) {
      const isValidToken = await this.validateTokenPayload();
      valid = token !== "" && isValidToken;
    }
    return Promise.resolve(valid);
  },
  async SetToken(token:string) {
    const payload:any = await this.GetTokenPayload(token);
    const mainDomain = this.GetMainDomain();
    document.cookie = "token="+token+";expires="+(new Date(payload.exp).toUTCString())+"; path=/; domain="+mainDomain;
    return storage.setItem(config.STORAGE_KEYS.TOKEN, token);
  },
  async SignOut() {
    await PermissionHelper.removePermission();
    await storage.removeItem(config.STORAGE_KEYS.TOKEN);
    await localStorage.removeItem("google-credential");
  },
  async GetTokenPayload(token:string|null=null) {
    if(token==null){
      token = await storage.getItem<string>("arch-pms-token");
    }
    if (token != null && token!="") {
      const base64Url = token.split(".")[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const jsonPayload = decodeURIComponent(atob(base64).split("").map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(""));
      return Promise.resolve(<IAuthToken>JSON.parse(jsonPayload));
    }
    return Promise.resolve(null);
  },
  async validateTokenPayload() {
    const currentToken = await Auth.GetTokenPayload();
    if(currentToken != null){
      const authToken = <IAuthToken>currentToken;
      const todayDate = new Date().getTime();
      const expiryDate = new Date(authToken.exp).getTime();
      return expiryDate > todayDate;
    }
    return false;
  },
  GetMainDomain(){
    const hostname = window.location.hostname;
    if(hostname.indexOf(".") == -1){
      return hostname;
    }

    const temps = hostname.split(".");
    if(temps.length > 2){
      return temps[temps.length - 2] + "." + temps[temps.length - 1];
    }
    return temps[temps.length - 1];
  },
};

export default Auth;
